import {UomTypeEnum} from '../enums/uomType.enum';

export class UomCriteriaDto {
  field: UomTypeEnum;
  leftValue: number;
  rightValue: number;
  leftMeasureId: number;
  rightMeasureId: number;
}
